/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type SbRespRefineMenuFilterCategory_itemSearch$ref = any;
export type SbRespRefineMenuFilterCategory_itemSearch = {
    readonly pageType: string | null;
    readonly totalResults: number | null;
    readonly isAttributePage: boolean | null;
    readonly appliedFilters: ReadonlyArray<{
        readonly name: string | null;
        readonly localizedFilterName: string | null;
        readonly canBeDismissed: boolean | null;
        readonly values: ReadonlyArray<{
            readonly urlLabel: string | null;
            readonly linkReference: string | null;
            readonly count: number | null;
            readonly displayName: string | null;
        } | null> | null;
    } | null> | null;
    readonly " $refType": SbRespRefineMenuFilterCategory_itemSearch$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SbRespRefineMenuFilterCategory_itemSearch",
    "type": "ItemSearchQueryConnection",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "pageType",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "totalResults",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "isAttributePage",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "appliedFilters",
            "storageKey": null,
            "args": null,
            "concreteType": "SearchBrowseParsedParam",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "name",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "localizedFilterName",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "canBeDismissed",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "values",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SearchBrowseParsedParamValue",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "urlLabel",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "linkReference",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "count",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "displayName",
                            "args": null,
                            "storageKey": null
                        }
                    ]
                }
            ]
        }
    ]
} as any);
(node as any).hash = 'ef38594c8b50fe13c09a8a5585c3a5be';
export default node;
